import {ProductsListFilterCols} from '@em/shared/api-interface';
import {FILTERABLE_COLUMNS} from '../consts/filterable-columns';

export function isFilterableColumn(val: string): val is ProductsListFilterCols {
  return (FILTERABLE_COLUMNS as string[]).includes(val);
}
